import {Obj, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

export const TV_LANGUAGE_OPTIONS = [
  {code: '', label: '-', name: 'Aucune préférence'},
  {code: 'en', label: 'EN', name: 'Anglais'},
  {code: 'fr', label: 'FR', name: 'Français'},
] as const;
export type TvPreferenceLanguage = (typeof TV_LANGUAGE_OPTIONS)[number]['code'];

export function isTvPreferenceLanguage(value: unknown): value is TvPreferenceLanguage {
  return TV_LANGUAGE_OPTIONS.some(option => option.code === value);
}

export const TvPreferencesSchema = Obj({
  preferredAudioLanguage: Str<TvPreferenceLanguage>(),
  preferredSubtitleLanguage: Str<TvPreferenceLanguage>(),
});
export type TvPreferences = SchemaToType<typeof TvPreferencesSchema>;

export function tvPreferences(value?: Partial<TvPreferences>): TvPreferences {
  return {
    preferredAudioLanguage: isTvPreferenceLanguage(value?.preferredAudioLanguage)
      ? value.preferredAudioLanguage
      : '',
    preferredSubtitleLanguage: isTvPreferenceLanguage(value?.preferredSubtitleLanguage)
      ? value.preferredSubtitleLanguage
      : '',
  };
}
